import React, { useState } from 'react';
import { Card, Form, Button } from 'react-bootstrap';
import rcmlogo from '../../assets/rcmlogo.png';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { PostApiMethod } from '../../core/services/apiService';
import { DisplayErrorMessages, DisplayToaster } from '../../core/services/sharedService';

const SetPassword = () => {

    const [searchParams] = useSearchParams();
    const user_type = window.location.pathname === "/setpassword" ? "admin" : "tenant";
    const user_id = window.location.pathname === "/setpassword" ? "userId" : "agentId";
    const [password, setPassword] = useState("");
    const [confpass, setConfpass] = useState("");
    const [passwordType, setPasswordType] = useState<string>("password");
    const [confpasswordType, setConfpasswordType] = useState<string>("password");
    const [responseData, setResponseData] = useState(false);
    const [type, setType] = useState(searchParams.get('type'));

    const navigate = useNavigate();

    const togglePassword = (e: any) => {
        if (passwordType === "password") {
            setPasswordType("text")
            return;
        }
        setPasswordType("password")
    }

    const toggleConfirmPassword = (e: any) => {

        if (confpasswordType === "password") {
            setConfpasswordType("text")
            return;
        }
        setConfpasswordType("password");
    }

    const handleSubmit = (event: any) => {
        event.preventDefault();
        if (!password) {
            DisplayToaster("bg-danger", "Password is required.");
            return false;
        } else if (!confpass) {
            DisplayToaster("bg-danger", "Confirm password is required.");
            return false;
        } else {
            if (!password.trim().match(/^.*(?=.{8,})(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%&!]).*$/)) {
                DisplayToaster("bg-danger", "Invalid password format.");
                return false;
            } else {
                if (password.trim() === confpass.trim()) {
                    const data = {
                        [user_id]: searchParams.get('id'),
                        token: searchParams.get('token'),
                        password: password.trim(),
                    };

                    PostApiMethod(user_type + '/auth/update_password', data)
                        .then((res) => {
                            if (res.data.status === "Success") {
                                setResponseData(true);
                                navigate('/sign-in');
                                DisplayToaster("bg-success", "Password updated successfully");
                            }
                        })
                        .catch((err) => {
                            DisplayToaster("bg-danger", DisplayErrorMessages(err) ? DisplayErrorMessages(err) : "Something went wrong!");
                        })
                } else {
                    DisplayToaster("bg-danger", "Password and confirm password should be same.");
                }
            }
        }
    }

    return (
        <>
            <div className="setcard">
                <Card className="" >
                    <Card.Img src={rcmlogo} alt="Card image" className="rcmlogo" />

                    <Card.Body>
                        <div className="m-3 text-info">
                            <small>Note : Passwords should contain a minimum of 8 characters, contain at least one uppercase letter, and contain at least one special character</small>
                        </div>
                        <Form onSubmit={handleSubmit}>
                            <div className="m-3">
                                <div className='mb-2'>
                                    <label><b>Enter Your Password Here</b> </label>
                                </div>
                                <div className='input-group' >
                                    <input type={passwordType} name="password" onChange={(e) => { setPassword(e.target.value.trim()) }} className="form-control input-textgenere" />
                                    <div className="input-group-append">
                                        <button className="btn btn-outline-primary" type="button" onClick={(e) => togglePassword(e)}>
                                            {passwordType === "password" ? <i className="bi bi-eye-slash"></i> : <i className="bi bi-eye"></i>}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="m-3">
                                <div className='mb-2'>
                                    <label><b>Confirm Your Password Here</b> </label>
                                </div>
                                <div className='input-group'>
                                    <input type={confpasswordType} name="confirmpassword" onChange={(e) => { setConfpass(e.target.value.trim()) }} className="form-control input-textgenere" />
                                    <div className="input-group-append">
                                        <button className="btn btn-outline-primary" type="button" onClick={(e) => toggleConfirmPassword(e)}>
                                            {confpasswordType === "password" ? <i className="bi bi-eye-slash"></i> : <i className="bi bi-eye"></i>}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="text-center" >
                                    {(type != null || type != "") ? <Button type='submit' style={{ backgroundColor: '#0187c4' }} className="m-3">Create Your Password</Button> : <Button type='submit' style={{ backgroundColor: '#0187c4' }} className="m-3">Reset Your Password</Button>}
                                </div>
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        </>
    );
}

export default SetPassword;